import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import applications from '@/store/modules/applications'
import events from '@/store/modules/events'
import schedules from '@/store/modules/schedules'
import wizardUploadProgress from '@/store/modules/wizard-upload'
import adminConversion from '@/store/modules/admin'

Vue.use(Vuex)

const localStoragePlugin = store => {
  store.subscribe((mutation, { accountNotifications }) => {
    const accountCode = store.getters.getActiveAccount?.accountCode
    if (
      accountCode &&
      ['SET_ACCOUNT_NOTIFICATIONS', 'ADD_ACCOUNT_NOTIFICATION', 'REMOVE_ACCOUNT_NOTIFICATION', 'CLEAR_ALL_ACCOUNT_NOTIFICATIONS'].includes(
        mutation.type
      )
    ) {
      localStorage.setItem(`account-notifications-${accountCode}`, JSON.stringify(accountNotifications))
    }
  })
}

const plugins = [localStoragePlugin]

const state = {
  serverEventsSource: undefined,
  showCodeSplittingRefresh: false,
  tokenIntervalName: '',
  accountRoles: {},
  accountTasks: [],
  accountNotifications: [],
  brokerages: {},
  brokerRoles: {},
  activeAccount: {
    accountCode: undefined,
    companyName: undefined,
    brokerCode: undefined,
    brokerName: undefined,
  },
  user: {},
  alert: {
    show: false,
    text: undefined,
  },
  dashboard: {
    applicationCycle: {
      accountId: undefined,
      isCurrent: undefined,
      sections: {},
    },
  },
  featuresLoaded: false,
  featureFlags: {},
  preferences: [],
  loading: false,
  auth: {
    isRefreshing: false,
    refreshingCall: undefined,
  },

  formModel: {
    forceUpdate: false,
    businessType: 0, // Corporation
    businessTypeOther: undefined,
    linesOfBusiness: [],
    linesOfBusinessPremiums: [],
    proposedEffDate: undefined,
    proposedExpDate: undefined,
    primaryContact: {
      name: undefined,
      phone: undefined,
      email: undefined,
    },
    primaryAddress: {
      line1: undefined,
      line2: undefined,
      city: undefined,
      state: undefined,
      zip: undefined,
    },
    primaryWebsite: undefined,
    premisesInformation: [
      {
        locationNumber: undefined,
        buildingNumber: undefined,
        line1: undefined,
        line2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
        annualRevenue: undefined,
        occSqFt: undefined,
        bldSqFt: undefined,
      },
    ],
    natureOfBusiness: [],
    businessStartDate: undefined,
    descriptionOfPrimaryOperations: undefined,
    descriptionOfOpsOtherNamed: undefined,
    additionalInterest: {
      name: undefined,
      interest: undefined,
      line1: undefined,
      line2: undefined,
      city: undefined,
      state: undefined,
      zip: undefined,
    },
    liabilityCoverage: {
      type: 0, // Commercial General Liability
      occurrence: true, // otherwise 'Cla
      limits: {
        type: 0, // Policy
        generalAggregate: '2,000,000',
        // limitsAppliesPer: 0, // Policy
        productsCompletedOperationsAggregate: '2,000,000',
        personalAndAdInjury: '1,000,000',
        eachOccurrence: '1,000,000',
        damageToRentedPremises: '300,000',
        medicalExpense: '10,000',
        employeeBenefits: undefined,
      },
    },
    scheduleOfHazards: [
      {
        locationNumber: undefined,
        hazardNumber: undefined,
        classification: undefined,
        classCode: undefined,
        premiumBasis: undefined,
        exposureAmount: undefined,
        terr: undefined,
      },
    ],
    products: [],
    grossSales: {
      domestic: undefined,
      foreign: undefined,
      pastYear: undefined,
      secondYearPrior: undefined,
      thirdYearPrior: undefined,
    },
    otherReceipts: null,
    otherReceiptsDetails: undefined,
    consideringOtherProducts: undefined,
    consideringOtherProductsDetails: undefined,
    consideringDiscontinuing: undefined,
    consideringDiscontinuingDetails: undefined,
    productsUsedInConnectionWith: [],
    productsOriginatedOutsideUsa: undefined,
    productsOriginatedOutsideDetails: undefined,
    productsOriginatedOutsideUsaCountries: undefined,
    othersManufactureUnderApplicantsName: undefined,
    applicantManufactureForOthers: undefined,
    applicantManufactureForOthersDetails: undefined,
    applicantSafetyCertification: undefined,
    applicantQualityControlProcedure: undefined,
    qualityControlRecordStoreLength: undefined,
    identityProductsFromCompetitors: undefined,
    recordsShowProductSales: undefined,
    requiresCoiFromSuppliers: undefined,
    designOwnProducts: undefined,
    designsReviewedByOthers: undefined,
    programToWithdrawDefects: undefined,
    consideredARecall: undefined,
    consideredARecallDetails: undefined,
    warningsReviewedByLegal: undefined,
    productsInvestigated: undefined,
    productsInvestigatedDetails: undefined,
    typeOfAttachedRequired: undefined,
    amountOfAttachedRequired: undefined,
    currentProductLiabilityInsurance: undefined,
    currentProductLiabilityInsuranceLimits: undefined,
    currentProductLiabilityInsuranceDeductible: undefined,
    currentProductLiabilityInsuranceExpiration: undefined,
    currentProductLiabilityInsuranceRetroactive: undefined,
    productGeneralLiabilityClaims: undefined,
    productGeneralLiabilityClaimsList: [],
    awareOfPotentialLiabilityClaims: undefined,
    awareOfPotentialLiabilityClaimsDetails: undefined,
  },
  redirectUrl: undefined,
}

export default new Vuex.Store({
  modules: {
    applications: applications,
    events: events,
    schedules: schedules,
    wizardUploadProgress: wizardUploadProgress,
    adminConversion: adminConversion,
  },
  state: state,
  actions,
  getters,
  mutations,
  plugins,
})
